/* eslint-disable */
/* eslint-disable camelcase */
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import swal from 'sweetalert';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import moment from 'moment';
// material
import { Table, TableRow, TableBody, TableCell, TableContainer, TablePagination } from '@mui/material';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import EventCalender from './EventCalender';
import { EventCalendarListHead, EventCalendarListToolbar } from '../../sections/@dashboard/eventCalendar';
import {
  getSitterAllocationDataForAllocate,
  getCalendarDataForAllocate,
  sitterAllocate,
} from '../../common/api-service';

function AllocationPage() {
  const { rowData } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();

  const [data, setData] = useState([]);
  const [eventsData, setEventsData] = useState([]);

  const getCalendarAllocationData = JSON.parse(localStorage.getItem('calData'));
  const [eData, setEData] = useState(getCalendarAllocationData);
  const [allocateData, setAllocateData] = useState([]);

  const TABLE_HEAD = [
    { id: 'user_name', label: 'User Name', alignRight: false },
    { id: 'book_services_id', label: 'Booking No', alignRight: false },
    { id: 'service_name', label: 'Service', alignRight: false },
    { id: 'date', label: 'Start Date', alignRight: false },
    { id: 'time_slot', label: 'Time Slot', alignRight: false },
    { id: 'number_of_pets', label: 'Number of Pets', alignRight: false },
    { id: 'number_of_sessions', label: 'Sessions', alignRight: false },
    { id: 'package_title', label: 'Package', alignRight: false },
    { id: 'target_pet', label: 'Pet Type', alignRight: false },
    { id: 'subscription', label: 'Subscription', alignRight: false },
    { id: '' },
  ];

  const handleAllocate = (card, index) => {
    const payload = {
      type: eData.service_name,
      sitter_id: card._id,
      _id: eData._id,
      book_service_id: eData.book_services_id,
    };
    return sitterAllocate(payload).then((res) => {
      if (res.data.status === true) {
        const data = res.data.data;
        setAllocateData(data);
        localStorage.removeItem('getAllocationID');
        swal({
          title: res.data.message,
          icon: 'success',
          timer: 2000,
          button: false,
        });
        navigate('/dashboard/sitterAllocation', { replace: true });
      } else {
        console.log('error');
      }
    });
  };

  const getAllocationID = () => {
    const getAllocationID = localStorage.getItem('getAllocationID');
    const getAllocationDate = localStorage.getItem('getAllocationDate');
    const selectedAllocationRow = localStorage.getItem('selectedAllocationRow');

    const payload = {
      service_master_id: getAllocationID,
      start_date: getAllocationDate,
    };
    return getSitterAllocationDataForAllocate(payload).then((res) => {
      if (res.data.status === true) {
        const data = res.data.data;
        setData(data);
      } else {
        console.log('error');
      }
    });
  };
  useEffect(() => {
    getAllocationID();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'all',
  });

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: 'auto',
    width: '100%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 1,
  };
  const [open, setOpen] = React.useState(false);

  const getCalendarID = () => {
    const getCalendarID = localStorage.getItem('getCalendarID');
    const payload = {
      sitter_id: getCalendarID,
    };
    if (getCalendarID) {
      return getCalendarDataForAllocate(payload).then((res) => {
        if (res.data.status === true) {
          const data = res.data.data;
          setEventsData(data);
        } else {
          console.log('error');
        }
      });
    }
  };

  const handleClick = (sitter_id) => {
    localStorage.setItem('getCalendarID', sitter_id);
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Page title="User">
        <Container>
          <Card>
            <EventCalendarListToolbar />
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <EventCalendarListHead headLabel={TABLE_HEAD} rowCount={eData.length} />
                  <TableBody>
                    <TableRow hover key={eData.book_services_id} tabIndex={-1}>
                      <TableCell align="left">{eData.user_name}</TableCell>
                      <TableCell component="th" scope="row" padding="none">
                        {eData.book_services_id}
                      </TableCell>
                      <TableCell align="left">
                        <Typography sx={{ fontSize: '10pt' }} wordWrap>
                          {eData.service_name}
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography sx={{ fontSize: '10pt' }}>{moment(eData.date).format('YYYY-MM-DD')}</Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography sx={{ fontSize: '10pt' }} wordWrap>
                          {eData.time_slot}
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography sx={{ fontSize: '10pt' }}>{eData.number_of_pets}</Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography sx={{ fontSize: '10pt' }}>{eData.number_of_sessions}</Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography sx={{ fontSize: '10pt' }}>{eData.package_title}</Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography sx={{ fontSize: '10pt' }}>{eData.target_pet}</Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography sx={{ fontSize: '10pt' }}>{eData.subscription}</Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          </Card>
        </Container>
      </Page>
      <Box sx={{ width: '100%' }}>
        <Grid container direction="row" spacing={2} sx={{ overflow: 'auto', minHeight: '80vh' }}>
          {data?.map((card, index) => (
            <Grid item xs={6}>
              <Card
                sx={{
                  margin: 2,
                  width: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Grid>
                  <CardContent>
                    <Grid>
                      <Typography sx={{ fontWeight: 'bold' }}>{card.name}</Typography>
                    </Grid>
                    <Grid xs={1} sx={{ textAlign: 'justify' }}>
                      <Typography sx={{ textAlign: 'right', fontWeight: 'bold', mb: 1 }}>{card.city}</Typography>
                    </Grid>
                    <Grid container>
                      <Grid item xs={6}>
                        {card.sessions.map((sessions) => (
                          <Typography>{sessions.time_slot}</Typography>
                        ))}
                      </Grid>
                      <Grid item xs={6}>
                        {card.service_master?.map((service) => (
                          <Typography>{service}</Typography>
                        ))}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Grid>
                <Grid sx={{ m: 1 }}>
                  <CardActions>
                    <Button variant="contained" onClick={() => handleAllocate(card, index)} size="small" sx={{ mr: 2 }}>
                      Allocate
                    </Button>
                    <Button
                      size="small"
                      onClick={() => {
                        handleClick(card._id);
                        getCalendarID();
                        return handleOpen();
                      }}
                    >
                      View Calender
                    </Button>
                  </CardActions>
                </Grid>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Grid container>
          <Grid item xs={12}>
            <Button onClick={handleClose} color="error" sx={{ float: 'right' }}>
              X
            </Button>
          </Grid>
          <Grid item sx={{ mt: 1 }} xs={12}>
            <EventCalender eventsCalenderData={eventsData} allocateData={eData} />
          </Grid>
        </Grid>
      </Modal>
    </>
  );
}

export default AllocationPage;
